export default __webpack_public_path__ + "static/media/Gents-Glamor2.6c0e29bd.png";